module.exports = __webpack_public_path__ + "static/media/7sirpalmerrough.2f2de3b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/7sirpalmerrough.png
// module id = 106
// module chunks = 0